import { ApiServiceProvider } from "./api-service";
import { Injectable } from "@angular/core";
import { RequestGetAllPageAccessibleModel } from "../../model/app-page.model";

@Injectable()
export class AppPageApi2 {
  constructor(
    private apiServiceProvider: ApiServiceProvider) {
  }

  async getAllPageAccessible(data: RequestGetAllPageAccessibleModel) {
    return await this.apiServiceProvider.apiPB('POST', null, data, '/app-page/getAllPageAccessible', null, true)
  }

}



// WEBPACK FOOTER //
// ./src/pagebuilder/services/api/app-page.api.ts